import {
  type WorkplaceProfileResponse,
  workplaceProfileResponseSchema,
  workplaceProfileUpdateSchema,
} from "@clipboard-health/contract-backend-main";
import { patch } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

interface UpdateChartingRecallParams {
  workplaceId: string;
  chartingRecall: {
    enabled: boolean;
    recallGracePeriodDurationInHours: number;
  };
}

export function useUpdateChartingRecall(
  options: UseMutationOptions<WorkplaceProfileResponse, unknown, UpdateChartingRecallParams> = {}
) {
  return useMutation({
    mutationFn: async ({ workplaceId, chartingRecall }) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${workplaceId}`,
        data: {
          data: {
            id: workplaceId,
            type: "workplace",
            attributes: { chartingRecall },
          },
        },
        requestSchema: workplaceProfileUpdateSchema,
        responseSchema: workplaceProfileResponseSchema,
      });
      return response.data;
    },
    ...options,
  });
}
